import { createToolParameters } from '@goat-sdk/core';
import { z } from 'zod';

export const noParameters = z.object({});
export class NoParameters extends createToolParameters(noParameters) {}
